<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
  changeSteps?: () => void // optional callback used by the old flow
}>()

// Validation: a type must be selected
const rules = {
  umsokn: {
    tegund: { required }
  }
}
const v$ = useVuelidate(rules, { umsokn })

function onChange() {
  props.changeSteps?.()
}

// Called by ApplicationBase before advancing
async function validate(): Promise<boolean> {
  await v$.value.$validate()
  return !v$.value.$error
}

defineExpose({ validate })
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('utgreidsla_umsokn_step2_tegund') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-radio-group
            v-model="umsokn.tegund"
            :readonly="props.disable"
            hide-details
            @update:model-value="onChange"
          >
            <v-radio
              :label="t('utgreidsla_umsokn_step2_tegund_almenn')"
              :value="0"
            />
            <v-radio
              :label="t('utgreidsla_umsokn_step2_tegund_ororku')"
              :value="1"
            />
            <v-radio
              :label="t('utgreidsla_umsokn_step2_tegund_andlat')"
              :value="2"
            />
            <v-radio
              :label="t('utgreidsla_umsokn_step2_tegund_tilgreindSereign')"
              :value="4"
            />
          </v-radio-group>

          <div class="error__text" v-if="v$.umsokn.tegund.$error">
            {{ t('common.val_required') }}
          </div>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-b-40 { margin-bottom: 40px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
.error__text {
  color: #b00020; /* Vuetify default error color */
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
